import React, { useEffect, useState } from "react";
import "../App.css";
import Hero from "../components/Hero";
import "./Home.css";
import Cards from "../components/Cards/Cards";
import pool from "../images/pool4.jpg";
import { Button } from "../components/Button/Button";
import Counter from "../components/Counter/Counter";
import Process from "../components/Process";
import SEO from "../components/SEO";

function Home() {
    const [fade, setFade] = useState(false);

    useEffect(() => {
        const fadeIn = () => {
            setFade(window.scrollY >= 90);
        };

        fadeIn();
        window.addEventListener("scroll", fadeIn);

        return () => window.removeEventListener("scroll", fadeIn);
    }, []);

    return (
        <>
            <SEO
                title="MICO Pool Design and Consulting | Custom 3D Pool Designs"
                description="MICO Pool Design and Consulting creates custom 3D pool, patio, kitchen, stucco, and backyard designs for outdoor living spaces."
            />
            <div className="home">
                <Hero />
                <div className="home-about">
                    <div className={fade ? "left" : "left left-fade"}>
                        <div className="statistics">
                            <h1>
                                <Counter target={5000} />
                            </h1>
                            <p>Custom Pools Designed</p>
                            <h1>
                                <Counter target={2006} />
                            </h1>
                            <p>Designing Since</p>
                            <h1>100%</h1>
                            <p>Customer Satisfaction</p>
                        </div>
                        <img className="image-home" src={pool} alt="Pool"></img>
                    </div>
                    <div className="right">
                        <h1>Innovative Designs for Unforgettable Backyard Escapes</h1>
                        <p>
                            At Mico Pool Designs and Consulting, our mission is
                            to transform your dream backyard into reality.
                            Whether you envision a cozy fireplace, a gourmet
                            kitchen, or a luxurious spa, we ensure your new
                            backyard includes all the features you desire. Our
                            exceptional designs speak for themselves.
                        </p>
                    </div>
                </div>
                <div className="home-mid">
                    <div className="home-mid-content">
                        <h1>Designs in 3D</h1>
                        <div className="home-mid-btn">
                            <Button
                                className="btns"
                                buttonStyle="btn--outline"
                                buttonSize="btn--large"
                                buttonLink="/gallery"
                            >
                                GALLERY
                            </Button>
                        </div>
                    </div>
                </div>
                <Process />
                <Cards />
            </div>
        </>
    );
}

export default Home;
